import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemArrowForward = function IconSystemArrowForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 12h16m0 0-6-6m6 6-6 6"
  }));
};